import React, {Fragment} from "react";
import {useFormikContext} from "formik";
import {Col, Row} from "react-bootstrap";
import {CaseFormField} from "../../CaseGenerator";
import {TranslatedText} from "../../../../helpers/helpers";

const DigitalizzazioneDocument = (props) => {
  const {layout, fields} = props;
  const {fields: layoutFields} = layout;
  const {values} = useFormikContext();



  const isConditionMet = (conditionProps) => {
    if (!conditionProps) {
      return true;
    }
    const conditions = conditionProps;
    if (conditions.length === 0) {
      return true;
    }

    let allowed = false;
    if(conditions.length === 2 && (conditions[0].if === 'sign' || conditions[1].if === 'sign')) {
     if(values[conditions[0].if] !== 'spid') {
       if(values[conditions[0].if] === conditions[0].is && conditions[1].is === true) {
         allowed = true;
       }
     } else {
       if(values[conditions[1].if] === conditions[1].is && conditions[0].is === true) {
         allowed = true;
       }
     }

    }  else {
      conditions.forEach((condition) => {
        if (values[condition.if] === condition.is) {
          allowed = true;
        }
      });
    }


    return allowed;
  };

  return (
    <Fragment key={layout.title}>
      <p className={"case-step-mandatory-fields-legend paragraph-small-fs9"}><TranslatedText i18nKey="mandatory.fields.legend"/></p>
      <h2 className="case-step-title">{layout.title}</h2>
      <Row>
        {layoutFields &&
        layoutFields.map((item, index) => {
          const gridProps = item.grid;
          const conditionProps = item.condition || null;
          const fieldProps = fields[item.fieldName];
          const conditionMet = isConditionMet(conditionProps);
          return (
            conditionMet && (
              <Col {...gridProps} key={index}>
                {!item.fieldName && (
                  <h3 className="form-section-title">{item.text}</h3>
                )}
                {item.fieldName && <CaseFormField {...fieldProps} />}
              </Col>
            )
          );
        })}
      </Row>
    </Fragment>
  );
}

export default DigitalizzazioneDocument;
